export default {
  'order.CopiedSuccessfully': '已成功复制!',
  'order.ReplicationIsNotSupported': '不支持复制',
  'order.YourApplicationHasBeenSuccessfulPleaseCheckTheOrderStatusLater':
    '您的申请已成功，请稍后查看订单状态',
  'order.TheSystemIsDeserted': '系统开小差啦！',
  'order.ParameterError': '参数错误!',
  'order.TransferToBePaid': '转单待付款',
  'order.OrderHasBeenTransferred': '已转单',
  'order.SignUpAndPayNow': '立即签约支付',
  'order.ApplyForADeduction': '申请扣款',
  'order.growBeans': '成长豆',
  'order.MyShippingAddress': '我的收货地址',
  'order.LogisticsInformation': '物流信息：',
  'order.openRecord': '开通记录',
  'order.callOfficial': '叫叫官方',
  'order.CheckRefund': '查看退款',
  'order.TotalEquityPayable': '权益应付总额',
  'order.totalPrice': '商品总价',
  'order.freight': '运费',
  'order.AmountToBeCarriedForward': '转单结转金额',
  'order.transferFee': '转单费用',
  'order.TransferDiscount': '转单优惠',
  'order.FirstInstallmentDiscount': '优惠抵扣',
  'order.CompensationDiscounts': '补差优惠抵扣',
  'order.DeductionInstructions': '扣费说明',
  'order.Payable': '应付款：',
  'order.realPayment': '实付款：',
  'order.toPay': '去支付',
  'order.SubscriptionPay': '订阅实付',
  'order.PayForUpgrade': '升级实付',
  'order.coupon': '优惠券',
  'order.orderNumber': '订单编号',
  'order.copy': '复制',
  'order.orderTime': '下单时间',
  'order.paymentMethod': '支付方式',
  'order.PaymentTime': '支付时间',
  'order.Ship': '发货',
  'order.deliveryTime': '发货时间',
  'order.TransferOrderType': '转单类型',
  'order.transferToYourself': '转给自己',
  'order.transferToOthers': '转给其他人',
  'order.TransferOrderObject': '转单对象',
  'order.TurnoverTime': '转单时间',
  'order.UpgradeInformation': '升级信息',
  'order.hint': '提示',
  'order.understood': '知道了',
  'order.ToPayForTheOrderPleasePayInTheOrderLogisticsOfTheCallOfficialAccount':
    '支付该订单请在【叫叫】公众号的订单物流中进行支付',
  'order.PleaseEnsureThatYourContractAccountBalanceIsSufficientBeforeMakingADeductionApplication':
    '请保障您的签约账户余额充足后再进行扣款申请',
  'order.Cancel': '取消'
};
